import React, { useContext, useEffect } from 'react';
import { string, func, arrayOf, shape } from 'prop-types';
import classNames from 'classnames/bind';
import {
  Col, Row
} from '@thd-olt-component-react/core-ui';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import styles from './car-picker.module.scss';
import { dataModel } from './dataModel';
import { CarPickerContextProvider } from '../context/CarPickerContext';
import { CarPickerButtons } from './subcomponents/car-picker-buttons/car-picker-buttons';
import { CarPickerRedirect } from './subcomponents/car-picker-redirect/car-picker-redirect';
import { CarPickerBanner } from './subcomponents/car-picker-banner/car-picker-banner';

import { CarPickerContent } from './subcomponents/car-picker-content/car-picker-content';

const classes = classNames.bind(styles);

const CarPicker = ({
  nValue, pageType, onCarSelectionChange, onCarPickerUrlRedirect, appliedDimensions, pipRedirectUrlLabel
}) => {
  const { channel } = useContext(ExperienceContext);
  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('car-picker.ready');
  }, []);
  let navParam = nValue.split('Z');
  navParam = navParam?.[1] || navParam[0];
  const isPip = pageType === 'pip';
  const isMobile = channel === 'mobile';
  const isPlpDesktop = !isPip && !isMobile;

  let carPickerClasses = classes('car-picker', {
    'car-picker--pip-desktop': isPip && !isMobile
  });

  let selectionsButtonsClasses = classes('car-picker__selections-buttons-wrapper', {
    'car-picker__selections-buttons-wrapper--mobile': isMobile,
    'car-picker__selections-buttons-wrapper--browse-and-search': isPlpDesktop
  });

  let buttonsClasses = classes('car-picker__buttons', {
    'car-picker__buttons--mobile': isMobile,
    'car-picker__buttons--browse-and-search': isPlpDesktop
  });

  if (!navParam.length) {
    return null;
  }

  return (
    <CarPickerContextProvider
      navParam={navParam}
      pageType={pageType}
      onCarSelectionChange={onCarSelectionChange}
      onCarPickerUrlRedirect={onCarPickerUrlRedirect}
      appliedDimensions={appliedDimensions}
      pipRedirectUrlLabel={pipRedirectUrlLabel}
    >
      <div className={carPickerClasses}>
        {isPip && (
          <Row className={classes('car-picker__top-row')}>
            <Col className={classes('car-picker__banner')} nopadding>
              <CarPickerBanner />
            </Col>
            <CarPickerRedirect />
          </Row>
        )}
        <Row className={classes('car-picker__bottom-row')}>
          <Col nopadding>
            <div className={selectionsButtonsClasses}>
              <CarPickerContent isMobile={isMobile} />

              {!isMobile && (
                <div className={classes('car-picker__buttons')}>
                  <CarPickerButtons />
                  {!isPip && <CarPickerRedirect />}
                </div>
              )}
            </div>
            {isMobile && (
              <>
                <div className={buttonsClasses}>
                  <CarPickerButtons />
                </div>
                {!isPip && (
                  <div className={classes('car-picker__redirect--mobile')}>
                    <CarPickerRedirect />
                  </div>
                )}
              </>
            )}
          </Col>
        </Row>
      </div>
    </CarPickerContextProvider>
  );
};

CarPicker.propTypes = {
  nValue: string.isRequired,
  pageType: string,
  onCarSelectionChange: func,
  onCarPickerUrlRedirect: func,
  appliedDimensions: arrayOf(shape({})),
  pipRedirectUrlLabel: string
};

CarPicker.defaultProps = {
  pageType: 'browse',
  onCarSelectionChange: () => {},
  onCarPickerUrlRedirect: undefined,
  appliedDimensions: [],
  pipRedirectUrlLabel: 'Related Products'
};

CarPicker.displayName = 'CarPicker';

CarPicker.dataModel = dataModel;

export { CarPicker };
